import { instance4, TYPE_INSTANCE4 } from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  fetchData,
} from "App/utils/helpers";
import { makeStyles } from "@material-ui/core/styles";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";

export const urlGet = LIST_URL_WAREHOUSE.masterGudang.getGudang;
export const urlDelete = LIST_URL_WAREHOUSE.masterGudang.delete;
export const urlUpdate = LIST_URL_WAREHOUSE.masterGudang.update;
export const urlGudangUnit = LIST_URL_WAREHOUSE.masterGudang.getGudangUnit;
export const urlAdd = LIST_URL_WAREHOUSE.masterGudang.add;

export const RESET_STATE_MASTER_GUDANG_UTAMA = {
  id: "",
  idunit: "",
  unit_name: "",
  idgudang: 1,
  name: "",
  idjenis: 1,
  remark: null,
  status: null,
};

export const STYLE_MASTER_GUDANG_UTAMA = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
});

export const getAllMasterGudangUtama = async () => {
  try {
    const api = await instance4.get(urlGet);
    const res = api.data;
    return res.body;
  } catch (error) {
    defaultToastError(error?.response?.data?.message);
    return false;
  }
};

export const convertJenisGudangUtama = (id) => {
  switch (id) {
    case 1:
      return "Perbekalan Farmasi";

    case 2:
      return "Logistik";

    case 3:
      return "Fix Asset";

    case 4:
      return "Non CC";

    default:
      return "Tidak ditemukan";
  }
};

export const dataDropdownJeniGudangUtama = [
  {
    value: 1,
    label: "Perbekalan Farmasi",
  },
  {
    value: 2,
    label: "Logistik",
  },
  {
    value: 3,
    label: "Fix Assets",
  },
  {
    value: 4,
    label: "Non CC",
  },
];

export const deleteMasterGudangUtamaById = async (
  id,
  setRows,
  setShowModalDeleteConfirm,
  setFormData
) => {
  try {
    await instance4.delete(`${urlDelete}/${id}`);
    const newData = await fetchData(TYPE_INSTANCE4, urlGet);
    setRows(newData);
    setShowModalDeleteConfirm(false);
    setFormData(RESET_STATE_MASTER_GUDANG_UTAMA);
    return defaultToastSuccess("Data berhasil dihapus");
  } catch (error) {
    return defaultToastError(error?.response?.data?.message);
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    sort: false,
    align: "center",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA GUDANG",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "type_gudang",
    disablePadding: false,
    label: "JENIS",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "namaunit",
    disablePadding: false,
    label: "NAMA UNIT",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];
